module.exports = __webpack_public_path__ + "img/7.dbcd3132.png";